import { useState,useEffect } from "react";
import { Button, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { deleteClient } from "../../../store/actions/clientsAction";
import Popup from "../../common/modal/Popup";
import Loader from "../../common/loader/Loader";
const DeleteClientPopup = ({deleteRec, onHide, deleteModalShow, setDeleteModalShow}) => {
    const {
        isRecordUpdated,
        error: apiError,
        isLoader,
    } = useSelector(state => {return state.clients});
    const [isAction, setIsAction] = useState(false)
    const [isDone, setIsDone] = useState(false)
    const dispatch = useDispatch();


    const submitHandler = (mode) => {
        setIsAction(true);
        return dispatch(deleteClient({
                clientId: deleteRec,
            }))
            
    }
    useEffect(() => {
        if(isRecordUpdated){
            setIsDone(true);
            onHide()
            setDeleteModalShow(false)
            }  
    }, [isRecordUpdated])

    return (
        <>
            <Popup
                onHide={() => onHide()}
                size="md"
                show={deleteModalShow}
                title={"Delete Client"}
                footer={
                    <>
                        <Button variant="outline-secondary model-btn" onClick={(e) => onHide()}>Cancel</Button>
                        <Button className='btn-primary model-btn' onClick={(e) => submitHandler()}>Confirm</Button>
                    </>
                }
            >
                {isLoader && <Loader />}
                 {
                    apiError &&
                    <Alert variant={'danger'}>
                        {apiError?.message || 'Access denied! Please try again'}
                    </Alert>
                 }
                <div style={{textAlign: "center"}}>
                    {
                        "Are you sure you want to delete this client?"
                    }
                </div>
            </Popup>
            
        </>
    )
}

export default DeleteClientPopup;